<template>
    <div class="form-contact mt-5">
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
            <form action="#" method="post" name="contact_form" class="form_default mb-5" @submit.prevent="handleSubmit(onSubmit)">
                <h3 class="form-contact-title">Fale conosco</h3>
                <hr>
                <div class="row mt-5">
                    <div class="col-sm-6 col-md-4">
                        <ValidationProvider name="nome" rules="required" slim v-slot="{ errors, classes, required }">
                            <div class="form-group">
                                <label for="contact_name" class="form-contact-label">Nome<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                <input type="text" id="contact_name" name="contact_name" class="form-control" v-model="name" :class="classes">
                                <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-sm-6 col-md-4">
                        <ValidationProvider name="e-mail" rules="required|email" slim v-slot="{ errors, classes, required }">
                            <div class="form-group">
                                <label for="contact_email" class="form-contact-label">E-mail<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                <input type="email" id="contact_email" name="contact_email" class="form-control" v-model="email" :class="classes">
                                <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-sm col-md-4">
                        <ValidationProvider name="telefone" :rules="{ required: true, regex: /^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/ }" slim v-slot="{ errors, classes, required }">
                            <div class="form-group">
                                <label for="contact_phone" class="form-contact-label">Telefone<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                <the-mask type="tel" inputmode="numeric" id="contact_phone" name="contact_phone" class="form-control" v-model="phone" :class="classes" :mask="['(##) ####-####', '(##) #####-####']" :masked="true"/>
                                <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="mensagem" rules="required" slim v-slot="{ errors, classes, required }">
                            <div class="form-group">
                                <label for="contact_message" class="form-contact-label">Mensagem<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                <textarea name="contact_message" id="contact_message" cols="30" rows="10" class="form-control" v-model="message" :class="classes"></textarea>
                                <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
                <recaptcha :data-sitekey="$wdconfig.default.recaptcha_site"/>
                <FormMessage :msg="msg_form" :type="msg_form_type"></FormMessage>
                <div class="d-flex justify-content-end mt-3 pb-5">
                    <button type="submit" class="btn-default btn-square pr-5 pl-5" :disabled="sending">{{ sending ? 'Enviando' : 'Enviar' }}</button>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {TheMask} from "vue-the-mask";
import FormMessage from "~/components/FormMessage";

export default {
    components: {
        FormMessage,
        ValidationProvider,
        ValidationObserver,
        TheMask
    },
    data: function () {
        return {
            name: '',
            email: '',
            phone: '',
            message: '',
            token: "",
            sending: false,
            msg_form: '',
            msg_form_type: ''
        }
    },
    methods: {
        reset() {
            this.name = '';
            this.email = '';
            this.phone = '';
            this.message = '';
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        async onSubmit() {
            this.msg_form = ''
            const params = new URLSearchParams();
            params.append('name', this.name);
            params.append('email', this.email);
            params.append('phone', this.phone);
            params.append('message', this.message);
            params.append('form_sistema', '6000');
            params.append('enviar', 'sim');
            params.append('g-recaptcha-response', await this.$recaptcha.getResponse());
            this.sending = true;
            this.$axios.$post('?p=form_ajax', params)
                .then((response) => {
                    if (response.enviado === 'sim') {
                        this.msg_form = 'Mensagem enviada!';
                        this.msg_form_type = 'success';
                        this.reset();
                    } else {
                        this.msg_form = 'Não foi possível enviar: ' + response.msg;
                        this.msg_form_type = 'error';
                    }
                })
                .catch(function (error) {
                    this.msg_form.text = 'Não foi possível enviar!';
                    this.msg_form.type = 'error';
                    console.error(error);
                })
            await this.$recaptcha.reset();
        }
    },
    watch: {
        sending(newvalue) {
            if (newvalue) {
                this.msg_form = ''
            }
        },
        msg_form(newvalue) {
            if (newvalue !== '') {
                this.sending = false
            }
        }
    }
};
</script>
